/**
 * Sub-accounts cannot access these pages.
 */

export default function({ to, from, store }) {
    let user = store.getters.user;
    if (user && user.is_sub_account) {
        return { name: 'dashboard' };
    }
}
